import React from "react";
import { IconType } from "react-icons";
import { AiFillContainer, AiFillPlaySquare, AiFillRead, AiOutlinePicture } from "react-icons/ai";
import { ReactComponent as DashboardIcon } from '../svgs/dashboard_icon.svg';
import { ReactComponent as Usericon } from '../svgs/user_icon.svg';
import { ReactComponent as Noticeicon } from '../svgs/notice_icon.svg';
import { ReactComponent as MaterialIcon } from '../svgs/material_icon.svg';
import { ReactComponent as SettingIcon } from '../svgs/setting_icon.svg';

const TutorialIcon: IconType = (props) => (
  React.createElement(AiFillRead, { color: "#E8EDFF", size: "1.4rem", ...props })
);

const BannerIcon: IconType = (props) => (
  React.createElement(AiFillPlaySquare, { color: "#E8EDFF", size: "1.35rem", ...props })
);

export const gnbConst = [
  { title: "대시보드", path: "/dashboard", icon: DashboardIcon, level: 100 },
  { title: "회원관리", path: "/user", icon: Usericon, level: 100 },
  { title: "공지사항", path: "/notice", icon: Noticeicon, level: 1 },
  { title: "튜토리얼 관리", path: "/tutorial", icon: TutorialIcon, level: 100 },
  { title: "베너 관리", path: "/banner", icon: BannerIcon, level: 100 },
  { title: "자료관리", path: "/material", icon: MaterialIcon, level: 1 },
  { title: "설정", path: "/setting", icon: SettingIcon, level: 100 },
];
